<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container mt-4 ">
    <div class="d-flex justify-content-center row mb-5">
      <div class="col-md-10 mb-3">
        <ngb-alert *ngIf="alert" [type]="alert.type" (close)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>
        <app-tok-header
          [title]="
            'The breeder of your pet has started the transfer of keepership to you.<br/><br/>You will need to complete and verify your details before we can complete the transfer. You will then be able to make the payment of ' + tokFee + ' and complete the transfer, which includes the first year of our identialert service.'
          "
          [subTitle]="
            'Set a password for your newly created account below to proceed.'
          "
        ></app-tok-header>
      </div>
      <div class="col-12 col-md-6 col-lg-5 mb-3" [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
        <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
          <div class="mb-0">
            <div>
              <div class="mb-3 input-container">
                <label class="form-label" for="firstName">Your email address</label>
                <img src="/assets/images/home/email_icon.svg" alt="search-icon" class="input-icon" />
                <input
                  class="form-control input-field"
                  [class.is-invalid]="false"
                  id="emailAddress"
                  name="emailAddress"
                  [(ngModel)]="model.emailAddress"
                  placeholder="Email address"
                  disabled
                  required
                  type="text"
                />
              </div>
            </div>
          </div>
          <form
            #passwordForm="ngForm"
            (ngSubmit)="claimAccount()"
            [appMatchingFields]="['password', 'passwordConfirm']"
            novalidate>

            <div class="mb-3">
              <div>
                <label class="form-label" for="password"> Password </label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <img src="/assets/images/home/password_icon.svg" alt="search-icon" class="password-icon" />
                  <input
                    matInput
                    #password="ngModel"
                    class="text-input-with-icon"
                    [type]="hidePassword ? 'password' : 'text'"
                    [class.is-invalid]="password.touched && !password.valid"
                    id="password"
                    name="password"
                    [(ngModel)]="model.password"
                    placeholder="Password"
                    required
                    passwordStrength
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidePassword"
                  >
                    <mat-icon>{{
                      hidePassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                  <mat-error
                    *ngIf="
                      (password.errors && password.errors.minlength) ||
                      (password.errors && password.errors.required)
                    "
                  >
                    {{
                      password.errors && password.errors.minlength
                        ? errorStrings.passwordTooShort
                        : errorStrings.required
                    }}
                  </mat-error>
                </mat-form-field>
                <app-zxcvbn-password-strength [password]="model.password" [control]="password" />
              </div>
            </div>

            <div class="mb-3">
              <div>
                  <label class="form-label" for="passwordConfirm"> Confirm password </label>
                </div>
                <div>
                  <mat-form-field appearance="outline" class="w-100">
                    <img src="/assets/images/home/password_icon.svg" alt="search-icon" class="password-icon" />
                    <input
                      matInput
                      #passwordConfirm="ngModel"
                      class="text-input-with-icon"
                      [type]="hideConfirmPassword ? 'password' : 'text'"
                      [class.is-invalid]="
                        passwordConfirm.touched && !passwordConfirm.valid
                      "
                      id="passwordConfirm"
                      minlength="8"
                      name="passwordConfirm"
                      ngModel=""
                      placeholder="Confirm password"
                      required
                    />
                    <button
                      mat-icon-button
                      type="button"
                      matSuffix
                      (click)="hideConfirmPassword = !hideConfirmPassword"
                      [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hideConfirmPassword"
                    >
                      <mat-icon>{{
                        hideConfirmPassword ? "visibility_off" : "visibility"
                      }}</mat-icon>
                    </button>
                    <mat-error
                      *ngIf="
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.required) ||
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.minlength) ||
                        (passwordConfirm.errors &&
                          passwordConfirm.errors.matchingFields)
                      "
                    >
                      {{
                        passwordConfirm.errors && passwordConfirm.errors.required
                          ? errorStrings.required
                          : passwordConfirm.errors &&
                            passwordConfirm.errors.minlength
                          ? errorStrings.passwordTooShort
                          : errorStrings.passwordMismatch
                      }}
                    </mat-error>
                  </mat-form-field>
                </div>
            </div>
            <button
              type="submit"
              class="btn btn-secondary text-white position-relative btn-lg w-100 mt-1"
              [ngClass]="{'btn-brand-orange': !useRebrandedLayout}"
              [disabled]="!passwordForm.valid || loading">
              <fa-icon
                *ngIf="loading"
                [icon]="['fas', 'spinner']"
                [animation]="'spin'"
                class="me-3"
              ></fa-icon>
              <img
              class="button-with-pawn"
              src="/assets/images/identibase/whitepawlarge.png"
              />
              Continue
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>